import HttpService from "../../constant/Api";

const API = "v1/wallet";

export const getWalletBalanceService = () => {
  return HttpService.get(`${API}/balance`);
};

export const getWalletTransactionsService = (
  params = { pageNumber: 0, pageSize: 10, sort: "ASC" }
) => {
  return HttpService.get(`${API}/subscriber/transaction`, { params });
};

export const getTransactionDetailService = (sessionId) => {
  return HttpService.get(`v1/session/detail/${sessionId}`);
};

export const handlePaymentService = (data) => {
  return HttpService.post(`v1/user/order/`, data);
};

export const getBankGatewayService = (
  params = { pageNumber: 0, pageSize: 10, sort: "ASC" }
) => {
  return HttpService.get(`v1/ipg/bank-gateway`, { params });
};

export const getValidationSubscriberService = (discountCode = "") => {
  return HttpService.get(`v1/discount/discount-userlog/valid/${discountCode}`);
};

export const sendInvoicesRequest = (transactionId) => {
  return HttpService.post(`v1/financial/invoices/${transactionId}`, {});
};

export const validateDiscountByCodeAndAmount = (code, amount) => {
  return HttpService.get(
    `/v1/discount/discount-userlog/validate/${code}/${amount}`
  );
};

export const setValidationUserLogService = (discountCode, total) => {
  let params = {
    amount: total,
    code: discountCode,
  };
  return HttpService.post(`/v1/discount/discount-userlog/validate`, params);
};
